import AssignDuty from "./AssignDuty/Routes/index.js";
import DutyPost from "./DutyPost/Routes/index.js";
import Reports from "./Reports/Routes/index.js";

export default [...AssignDuty, ...DutyPost, ...Reports];
